"use client";
import React, { useState, useEffect } from "react";
import ModalReportJob from "components/ModalReportJob";
import { postReportRequest } from "store/actions/reports/postReport";
import { initialState } from "store/reducers/config/fetchConfig";
import { postNotification } from "bossjob-remote/dist/clientStorage";
import { useSharedData } from "bossjob-remote/dist/hooks";
import styles from "./Reminder.pc.module.scss";

const Dot = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='4' height='3' viewBox='0 0 4 3' fill='none'>
    <circle cx='2' cy='1.45508' r='1.25' fill='#ACAEB1' />
  </svg>
);

const Reminder = ({ dictionary, jobId, sessionid }) => {
  const [reportJobReasonList, setReportJobReasonList] = useState(null);
  const isPostingReport = useSharedData("POST_REPORT_FETCHING");
  const [isShowReportJob, setIsShowReportJob] = useState<boolean>(false);
  const postReportResponse = useSharedData("POST_REPORT_RESPONSE");
  const config = useSharedData("CONFIG") ?? initialState.response;

  const handlePostReportJob = (reportJobData) => {
    const postReportJobPayload = {
      reportJobData
    };
    postNotification("DISPATCH", postReportRequest(postReportJobPayload));
  };
  useEffect(() => {
    setReportJobReasonList(config?.report_job_reasons ?? initialState.response.report_job_reasons);
  }, [config]);
  return (
    <>
      <div className={styles.reminder}>
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='24'
          height='25'
          viewBox='0 0 24 25'
          fill='none'
          className={styles.svg}
        >
          <g clipPath='url(#clip0_3456_2837)'>
            <path
              d='M11.4885 24.3006C11.642 24.4001 11.8188 24.4535 11.9993 24.4548C12.1799 24.4535 12.3567 24.4001 12.5102 24.3006C12.6772 24.1978 16.4789 21.731 17.805 20.7031C19.08 19.7215 20.1247 18.4491 20.8601 16.9824C21.1412 16.3858 21.3017 15.735 21.3317 15.0706V5.64528C21.3416 5.41856 21.2795 5.19478 21.1551 5.00884C21.0307 4.82291 20.851 4.68529 20.644 4.61744L12.2941 1.84227C12.1037 1.77002 11.895 1.77002 11.7046 1.84227L3.35469 4.61744C3.14769 4.68529 2.96798 4.82291 2.84359 5.00884C2.7192 5.19478 2.65712 5.41856 2.66704 5.64528V15.1014C2.70128 15.7553 2.86168 16.3951 3.13857 16.9824C3.87595 18.4477 4.92034 19.7196 6.19367 20.7031C7.55914 21.7721 11.3215 24.1978 11.4885 24.3006Z'
              fill='#0066FF'
            />
            <path
              d='M10.8977 16.455C10.9019 16.455 10.9061 16.4551 10.9103 16.4551H10.8899L10.8977 16.455Z'
              fill='white'
            />
            <path
              d='M10.5117 16.373C10.6337 16.425 10.7649 16.4528 10.8977 16.455C11.0353 16.4522 11.171 16.4219 11.2965 16.3657C11.4244 16.3085 11.5389 16.2257 11.6329 16.1226L17.3327 9.79513L15.806 8.45508L10.8492 13.9563L8.10113 11.0848L6.66602 12.4652L10.1775 16.1427C10.2721 16.241 10.3857 16.3193 10.5117 16.373Z'
              fill='white'
            />
          </g>
          <defs>
            <clipPath id='clip0_3456_2837'>
              <rect width='24' height='24' fill='white' transform='translate(0 0.455078)' />
            </clipPath>
          </defs>
        </svg>
        <h4>{dictionary.title}</h4>
        <p>{dictionary.firstPara}</p>
        <p>
          {dictionary.secondPara}{" "}
          <span
            className={styles.link}
            onClick={() => {
              if (!sessionid) {
                sessionStorage.setItem("redirectPage", window?.location?.pathname);
                postNotification("SHOW_LOGIN_MODAL");
                return;
              }
              setIsShowReportJob(true);
            }}
          >
            {dictionary.linkText}
          </span>
        </p>
        <ul>
          <li>
            <Dot />
            <span>{dictionary.list1}</span>
          </li>
          <li>
            <Dot />
            <span>{dictionary.list2}</span>
          </li>
          <li>
            <Dot />
            <span>{dictionary.list3}</span>
          </li>
          <li>
            <Dot />
            <span>{dictionary.list4}</span>
          </li>
          <li>
            <Dot />
            <span>{dictionary.list5}</span>
          </li>
        </ul>
      </div>
      {isShowReportJob && reportJobReasonList.length && (
        <ModalReportJob
          isShowReportJob={isShowReportJob}
          handleShowReportJob={setIsShowReportJob}
          reportJobReasonList={reportJobReasonList}
          selectedJobId={jobId}
          handlePostReportJob={handlePostReportJob}
          isPostingReport={isPostingReport}
          postReportResponse={postReportResponse}
        />
      )}
    </>
  );
};

export default Reminder;
